import { onBeforeUnmount, onMounted, ref } from 'vue';

import { rpcStorage } from '@/shared/lib/storage/rpc-storage';

import { tasksUpdatedBus } from './events';
import { FileItem } from './types';

export function useRpcTasks() {
  const tasks = ref<FileItem[]>([]);
  const load = () => {
    tasks.value = rpcStorage.get();
  };
  let off: (() => void) | undefined;
  onMounted(() => {
    load();
    off = tasksUpdatedBus.on(load);
  });
  onBeforeUnmount(() => {
    off?.();
  });
  return {
    tasks,
    reload: load,
  };
}
